module.exports = __webpack_public_path__ + "static/media/dinersclub.5f4bb707.png";